import * as React from "react";
import { SVGProps } from "react";
function SvgPlusIconSlim(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.855.37h-1.71v6.775H.37v1.71h6.776v6.776h1.71V8.855h6.776v-1.71H8.855V.37Z"
        fill="#fff"
      />
    </svg>
  );
}
export default SvgPlusIconSlim;
